module.exports = __webpack_public_path__ + "img/Step8.cc3d1ee4.png";